import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
// Import your images
import kabiniLogo from '../assets/images/kabini logo.jpg';

const Acontact = () => {
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 800,
      once: false,
      mirror: true,
      offset: 40,
      easing: 'ease-out-quad'
    });

    // Cleanup function
    return () => {
      // Cleanup if needed
    };
  }, []);

  // Social Icons SVG Sprites
  const socialIcons = (
    <svg style={{ display: 'none' }}>
      <symbol id="facebook" viewBox="0 0 24 24">
        <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z"/>
      </symbol>
      <symbol id="twitter" viewBox="0 0 24 24">
        <path d="M23.953 4.57a10 10 0 0 1-2.825.775 4.958 4.958 0 0 0 2.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 0 0-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 0 0-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 0 1-2.228-.616v.06a4.923 4.923 0 0 0 3.946 4.827 4.996 4.996 0 0 1-2.212.085 4.937 4.937 0 0 0 4.604 3.417 9.868 9.868 0 0 1-6.102 2.104c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 0 0 7.557 2.209c9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63a9.936 9.936 0 0 0 2.46-2.548l-.047-.02z"/>
      </symbol>
      <symbol id="linkedin" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451c.979 0 1.771-.773 1.771-1.729V1.729C24 .774 23.204 0 22.225 0z"/>
      </symbol>
      <symbol id="instagram" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.405a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z"/>
      </symbol>
      <symbol id="youtube" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </symbol>
    </svg>
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted');
    // You can add your form submission logic (API call, etc.)
  };

  return (
    <div className="acontact">
      {/* SVG Sprites */}
      {socialIcons}

      {/* Preloader */}
      <div className="preloader">
        <div className="loader"></div>
      </div>

      {/* Header */}
      <header id="header">
        <nav className="header-top bg-secondary py-1">
          <div className="container-fluid padding-side">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <ul className="info d-flex flex-wrap list-unstyled m-0">
                <li className="location text-capitalize d-flex align-items-center me-4" style={{ fontSize: '14px' }}>
                  <i className="fa fa-map-marker-alt" style={{ color: '#388E3C' }}></i> HD Kote Taluk, Karapura, Around Mysore - 571 114
                </li>
                <li className="phone d-flex align-items-center me-4" style={{ fontSize: '14px' }}>
                  <i className="fa fa-phone" style={{ color: '#388E3C' }}></i>9886228154
                </li>
                <li className="time d-flex align-items-center me-4" style={{ fontSize: '14px' }}>
                  <i className="fa fa-envelope" style={{ color: '#388E3C' }}></i>Info@kabinee.com
                </li>
              </ul>
              <ul className="social-links d-flex flex-wrap list-unstyled m-0">
                <li className="social">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#facebook"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#twitter"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#linkedin"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#instagram"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#youtube"></use>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <nav id="primary-header" className="navbar navbar-expand-lg py-4">
          <div className="container-fluid padding-side">
            <div className="d-flex justify-content-between align-items-center w-100">
              <Link className="navbar-brand" to="/">
                <img src={kabiniLogo} className="logo img-fluid" style={{ width: '18%' }} alt="Kabini Logo" />
              </Link>

              {/* Navbar Toggler Button */}
              <button className="navbar-toggler border-0 d-flex d-lg-none order-3 p-2 shadow-none" type="button"
                data-bs-toggle="offcanvas" data-bs-target="#bdNavbar" 
                aria-controls="bdNavbar" aria-expanded="false">
                <svg className="navbar-icon" width="40" height="40" style={{ color: '#000000', fill: 'currentColor' }}>
                  <rect x="10" y="12" width="20" height="2" fill="currentColor"/>
                  <rect x="10" y="22" width="20" height="2" fill="currentColor"/>
                  <rect x="10" y="32" width="20" height="2" fill="currentColor"/>
                </svg>
              </button>

              <div className="header-bottom offcanvas offcanvas-end" id="bdNavbar" aria-labelledby="bdNavbarOffcanvasLabel">
                <div className="offcanvas-header px-4 pb-0">
                  <h5 className="offcanvas-title" id="bdNavbarOffcanvasLabel">Menu</h5>
                  <button type="button" className="btn-close btn-close-black" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body align-items-center justify-content-center">
                  <div className="search d-block d-lg-none m-4"></div>
                  <ul className="navbar-nav align-items-center mb-2 mb-lg-0">
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/agroindex">Home</Link>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/about">About</Link>
                    </li>
                    <li className="nav-item px-3 dropdown">
                      <Link className="nav-link p-0 dropdown-toggle fw-bold" data-bs-toggle="dropdown" to="#" role="button" aria-expanded="false">Products</Link>
                      <ul className="dropdown-menu dropdown-menu-end animate slide mt-3 border-0 shadow">
                        {/* <li><Link to="/fruits" className="dropdown-item fw-bold">Fruits</Link></li> */}
                        <li><Link to="/vegetables" className="dropdown-item fw-bold">Vegetables</Link></li>
                        <li><Link to="/spices" className="dropdown-item fw-bold">Spices</Link></li>
                      </ul>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link active p-0 fw-bold" to="/acontact">Contact</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Contact Form Section */}
     <section className="padding-medium pt-0">
  <div className="container-fluid padding-side">
    <div className="row g-5">
      {/* ENQUIRY FORM CARD — spices focus */}
      <div className="col-lg-6" data-aos="fade-right">
        <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
          {/* Card Header with decorative element */}
          <div className="card-header bg-white border-0 pt-5 px-5">
            <div className="d-flex align-items-center mb-2">
              <div className="bg-success bg-opacity-10 p-3 rounded-circle me-3">
                <i className="fas fa-leaf text-success fs-4"></i>
              </div>
              <div>
                <span className="badge bg-warning text-dark mb-2">Fresh </span>
                <h3 className="display-6 fw-bold mb-0"> Enquiry</h3>
              </div>
            </div>
            <p className="text-muted ms-5 ps-5">Fill in the details below and we'll get back to you within 24 hours</p>
          </div>

          {/* Card Body with Form */}
          <div className="card-body px-5 pb-5">
            <form onSubmit={handleSubmit}>
              <div className="row g-4">
                {/* Personal Information Card */}
                <div className="col-12">
                  <div className="bg-light p-4 rounded-3">
                    <h6 className="fw-bold mb-3">
                      <i className="fas fa-user-circle me-2 text-success"></i>
                      Personal Information
                    </h6>
                    <div className="row g-3">
                      {/* Name */}
                      <div className="col-md-6">
                        <label className="form-label small fw-bold">Full name <span className="text-danger">*</span></label>
                        <input type="text" className="form-control form-control-lg rounded-3 border-0 shadow-sm" placeholder="Enter your name" required />
                      </div>
                      {/* Contact No */}
                      <div className="col-md-6">
                        <label className="form-label small fw-bold">Contact no <span className="text-danger">*</span></label>
                        <input type="tel" className="form-control form-control-lg rounded-3 border-0 shadow-sm" placeholder="Phone / mobile" required />
                      </div>
                      {/* Email Id */}
                      <div className="col-md-6">
                        <label className="form-label small fw-bold">Email id <span className="text-danger">*</span></label>
                        <input type="email" className="form-control form-control-lg rounded-3 border-0 shadow-sm" placeholder="abc@email.com" required />
                      </div>
                      {/* State & Country combined */}
                      <div className="col-md-3">
                        <label className="form-label small fw-bold">State</label>
                        <input type="text" className="form-control form-control-lg rounded-3 border-0 shadow-sm" placeholder="State" />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small fw-bold">Country</label>
                        <input type="text" className="form-control form-control-lg rounded-3 border-0 shadow-sm" placeholder="Country" />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Date Range Card */}
                <div className="col-12">
                  <div className="bg-light p-4 rounded-3">
                    <h6 className="fw-bold mb-3">
                      <i className="fas fa-calendar-alt me-2 text-success"></i>
                      Expected Timeframe
                    </h6>
                    <div className="row g-3 align-items-end">
                      <div className="col-md-3">
                        <label className="form-label small fw-bold">From date</label>
                        <input type="date" className="form-control form-control-lg rounded-3 border-0 shadow-sm" />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small fw-bold">To date</label>
                        <input type="date" className="form-control form-control-lg rounded-3 border-0 shadow-sm" />
                      </div>
                      <div className="col-md-6">
                        <div className="alert alert-success py-2 mb-0" role="alert">
                          <i className="fas fa-info-circle me-2"></i>
                          Flexible dates? Let us know in special requests
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Products Card */}
                <div className="col-12">
                  <div className="bg-light p-4 rounded-3">
                    <h6 className="fw-bold mb-3">
                      <i className="fas fa-seedling me-2 text-success"></i>
                      Select Spices / Products <span className="text-danger">*</span>
                    </h6>
                    
                    {/* Product Grid in Cards */}
                    <div className="row g-3">
                      {/* Ginger Card */}
                      <div className="col-md-3 col-6">
                        <div className="product-card p-2 text-center bg-white rounded-3 shadow-sm">
                          <div className="form-check">
                            <input className="form-check-input spice-check" type="checkbox" value="ginger" id="ginger" />
                            <label className="form-check-label d-block" htmlFor="ginger">
                              <i className="fas fa-plant d-block fs-2 text-success mb-2"></i>
                              <span className="small fw-bold">GINGER</span>
                              {/* <span className="d-block small text-muted">fresh/dried</span> */}
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Saffron Card */}
                      <div className="col-md-3 col-6">
                        <div className="product-card p-2 text-center bg-white rounded-3 shadow-sm">
                          <div className="form-check">
                            <input className="form-check-input spice-check" type="checkbox" value="saffron" id="saffron" />
                            <label className="form-check-label d-block" htmlFor="saffron">
                              <i className="fas fa-crown d-block fs-2 text-warning mb-2"></i>
                              <span className="small fw-bold">SAFFRON</span>
                              {/* <span className="d-block small text-muted">kashmiri/iranian</span> */}
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Turmeric Card */}
                      <div className="col-md-3 col-6">
                        <div className="product-card p-2 text-center bg-white rounded-3 shadow-sm">
                          <div className="form-check">
                            <input className="form-check-input spice-check" type="checkbox" value="turmeric" id="turmeric" />
                            <label className="form-check-label d-block" htmlFor="turmeric">
                              {/* <i className="fas fa-powder d-block fs-2 text-warning mb-2">🌾</i> */}
                              <span className="small fw-bold">TURMERIC</span>
                              {/* <span className="d-block small text-muted">fresh/powder</span> */}
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Thyme Card */}
                      <div className="col-md-3 col-6">
                        <div className="product-card p-2 text-center bg-white rounded-3 shadow-sm">
                          <div className="form-check">
                            <input className="form-check-input spice-check" type="checkbox" value="thyme" id="thyme" />
                            <label className="form-check-label d-block" htmlFor="thyme">
                              <i className="fas fa-leaf d-block fs-2 text-success mb-2"></i>
                              <span className="small fw-bold">THYME</span>
                              {/* <span className="d-block small text-muted">dried/organic</span> */}
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Bay Leaves Card */}
                      <div className="col-md-3 col-6">
                        <div className="product-card p-2 text-center bg-white rounded-3 shadow-sm">
                          <div className="form-check">
                            <input className="form-check-input spice-check" type="checkbox" value="bayLeaves" id="bayLeaves" />
                            <label className="form-check-label d-block" htmlFor="bayLeaves">
                              <i className="fas fa-tree d-block fs-2 text-success mb-2"></i>
                              <span className="small fw-bold">BAY LEAVES</span>
                              {/* <span className="d-block small text-muted">tej patta</span> */}
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Chia Seeds Card */}
                      <div className="col-md-3 col-6">
                        <div className="product-card p-2 text-center bg-white rounded-3 shadow-sm">
                          <div className="form-check">
                            <input className="form-check-input spice-check" type="checkbox" value="chiaSeeds" id="chiaSeeds" />
                            <label className="form-check-label d-block" htmlFor="chiaSeeds">
                              <i className="fas fa-seedling d-block fs-2 text-success mb-2"></i>
                              <span className="small fw-bold">CHIA SEEDS</span>
                              {/* <span className="d-block small text-muted">salvia hispanica</span> */}
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Curry Card */}
                      <div className="col-md-3 col-6">
                        <div className="product-card p-2 text-center bg-white rounded-3 shadow-sm">
                          <div className="form-check">
                            <input className="form-check-input spice-check" type="checkbox" value="curry" id="curry" />
                            <label className="form-check-label d-block" htmlFor="curry">
                              <i className="fas fa-utensils d-block fs-2 text-success mb-2"></i>
                              <span className="small fw-bold">CURRY</span>
                              {/* <span className="d-block small text-muted">leaves/powder</span> */}
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Other Spices Card */}
                      <div className="col-md-3 col-6">
                        <div className="product-card p-2 text-center bg-white rounded-3 shadow-sm">
                          <div className="form-check">
                            <input className="form-check-input spice-check" type="checkbox" value="otherSpices" id="otherSpices" />
                            <label className="form-check-label d-block" htmlFor="otherSpices">
                              <i className="fas fa-spice d-block fs-2 text-success mb-2"></i>
                              <span className="small fw-bold">OTHER</span>
                              {/* <span className="d-block small text-muted">cardamom, clove</span> */}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Additional spices input */}
                    <div className="mt-4">
                      <label className="form-label small fw-bold">
                        <i className="fas fa-plus-circle me-2 text-success"></i>
                        Additional spices / special requests
                      </label>
                      <input type="text" className="form-control rounded-3 border-0 shadow-sm" placeholder="e.g. organic turmeric, premium saffron, etc." />
                    </div>
                  </div>
                </div>

                {/* Quantity Card */}
                <div className="col-12">
                  <div className="bg-light p-4 rounded-3">
                    <h6 className="fw-bold mb-3">
                      <i className="fas fa-weight me-2 text-success"></i>
                      Quantity Details <span className="text-danger">*</span>
                    </h6>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label small fw-bold">Select quantity (kg)</label>
                        <select className="form-select form-select-lg rounded-3 border-0 shadow-sm" required defaultValue="">
                          <option value="" disabled>— select quantity —</option>
                          <option value="1">1 kg (Sample)</option>
                          <option value="5">5 kg (Small batch)</option>
                          <option value="10">10 kg (Medium batch)</option>
                          <option value="25">25 kg (Large batch)</option>
                          <option value="50">50 kg (Bulk order)</option>
                          <option value="100">100 kg (Wholesale)</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <div className="bg-white p-3 rounded-3 h-100 d-flex align-items-center">
                          <i className="fas fa-truck text-success fs-3 me-3"></i>
                          <div>
                            <small className="text-muted d-block">Bulk orders above 100kg</small>
                            <small className="fw-bold">Contact us for special pricing</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Submit button */}
                <div className="col-12 mt-4">
                  <button type="submit" className="btn btn-success btn-lg w-100 py-3 rounded-3 shadow-lg border-0">
                    <span className="d-flex align-items-center justify-content-center">
                      <i className="fas fa-paper-plane me-2"></i>
                      Send Spice Enquiry
                      {/* <span className="badge bg-white text-success ms-2 py-1 px-2">24h response</span> */}
                    </span>
                  </button>
                  <p className="text-center text-muted small mt-3">
                    <i className="fas fa-lock me-1"></i>
                    Your information is safe with us
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE: Map + Business Hours Cards */}
      <div className="col-lg-6" data-aos="fade-left">
        {/* Map Card */}
        <div className="card border-0 shadow-lg rounded-4 overflow-hidden mb-4">
          <div className="card-header bg-white border-0 pt-4 px-4">
            <div className="d-flex align-items-center">
              <div className="bg-success bg-opacity-10 p-2 rounded-circle me-2">
                <i className="fas fa-map-marker-alt text-success"></i>
              </div>
              <h5 className="fw-bold mb-0">Our Location</h5>
              <span className="badge bg-success ms-auto">Spice Sourcing Hub</span>
            </div>
          </div>
          <div className="card-body p-0">
            <div className="map-container position-relative" style={{ height: '300px' }}>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3172.3325395304414!2d-122.03261192467925!3d37.3318!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb5b6e1c0f1d9%3A0x8d8c8c8c8c8c8c8c!2sGreen%20Valley%2C%20CA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }}
                allowFullScreen 
                loading="lazy"
                title="spice-sourcing-hub"
              ></iframe>
            </div>
            <div className="p-3 bg-light">
              <div className="d-flex align-items-center">
                <i className="fas fa-map-pin text-success me-2"></i>
                <span className="small">HD Kote Taluk, Karapura, Around Mysore - 571 114</span>
                <button className="btn btn-sm btn-outline-success ms-auto">Get Directions</button>
              </div>
            </div>
          </div>
        </div>

        {/* Business Hours Card */}
        <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
          <div className="card-header bg-white border-0 pt-4 px-4">
            <div className="d-flex align-items-center">
              <div className="bg-warning bg-opacity-10 p-2 rounded-circle me-2">
                <i className="fas fa-clock text-warning"></i>
              </div>
              <h5 className="fw-bold mb-0">Business Hours</h5>
              <span className="badge bg-warning text-dark ms-auto">Spice Desk</span>
            </div>
          </div>
          <div className="card-body p-4">
            {/* Hours List */}
            <div className="hours-list">
              <div className="d-flex justify-content-between align-items-center p-3 bg-light rounded-3 mb-2">
                <span><i className="fas fa-calendar-day text-success me-2"></i>Monday - Friday</span>
                <span className="fw-bold bg-white px-3 py-1 rounded-pill">8:00 AM - 8:00 PM</span>
              </div>
              <div className="d-flex justify-content-between align-items-center p-3 bg-light rounded-3 mb-2">
                <span><i className="fas fa-calendar-day text-success me-2"></i>Saturday</span>
                <span className="fw-bold bg-white px-3 py-1 rounded-pill">9:00 AM - 6:00 PM</span>
              </div>
              <div className="d-flex justify-content-between align-items-center p-3 bg-light rounded-3">
                <span><i className="fas fa-calendar-day text-success me-2"></i>Sunday</span>
                <span className="fw-bold bg-white px-3 py-1 rounded-pill">10:00 AM - 4:00 PM</span>
              </div>
            </div>

            <hr className="my-4" />

            {/* Special Notice */}
            <div className="alert alert-success d-flex align-items-center" role="alert">
              <i className="fas fa-truck fs-4 me-3"></i>
              <div>
                <strong>Spice delivery available</strong><br />
                <small>During business hours only • Free delivery within 10 miles</small>
              </div>
            </div>

            {/* Contact Options */}
            <div className="row g-2 mt-3">
              <div className="col-6">
                <button className="btn btn-outline-success w-100 py-2">
                  <i className="fas fa-phone me-2"></i>Call Now
                </button>
              </div>
              <div className="col-6">
                <button className="btn btn-success w-100 py-2">
                  <i className="fas fa-envelope me-2"></i>Email Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Add this CSS in your stylesheet or as inline styles */}
  <style jsx>{`
    .product-card {
      transition: all 0.3s ease;
      cursor: pointer;
      border: 2px solid transparent;
    }
    .product-card:hover {
      transform: translateY(-5px);
      border-color: #28a745;
      box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
    }
    .product-card .form-check-input:checked + .form-check-label {
      color: #28a745;
    }
    .product-card .form-check-input:checked ~ .form-check-label i {
      color: #28a745;
    }
    .hours-list .bg-light {
      transition: all 0.3s ease;
    }
    .hours-list .bg-light:hover {
      background-color: #e9ecef !important;
      transform: translateX(5px);
    }
  `}</style>
</section>
      <br />

      {/* FAQ Section */}
      <section className="padding-medium">
        <div className="container-fluid padding-side" data-aos="fade-up">
          <div className="text-center mb-5">
            <h3 className="display-3 fw-normal">Frequently Asked Questions</h3>
            <p className="col-lg-6 offset-lg-3">Quick answers to common questions</p>
          </div>

          <div className="row g-4">
            <div className="col-md-6">
              <div className="bg-white p-4 rounded-4 shadow-sm h-100">
                <h5 className="fw-bold mb-3"><i className="fas fa-question-circle me-2" style={{ color: 'var(--fresh-green)' }}></i>How fresh is your produce?</h5>
                <p className="text-muted mb-0">All our vegetables and fruits are harvested within 24 hours of delivery. We work directly with local farmers to ensure maximum freshness.</p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="bg-white p-4 rounded-4 shadow-sm h-100">
                <h5 className="fw-bold mb-3"><i className="fas fa-question-circle me-2" style={{ color: 'var(--fresh-green)' }}></i>Do you offer delivery?</h5>
                <p className="text-muted mb-0">Yes, we offer free delivery within 10 miles of our farm. Delivery charges may apply for longer distances.</p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="bg-white p-4 rounded-4 shadow-sm h-100">
                <h5 className="fw-bold mb-3"><i className="fas fa-question-circle me-2" style={{ color: 'var(--fresh-green)' }}></i>Are your products certified organic?</h5>
                <p className="text-muted mb-0">Yes, all our products are certified organic by the USDA and we maintain strict quality control standards.</p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="bg-white p-4 rounded-4 shadow-sm h-100">
                <h5 className="fw-bold mb-3"><i className="fas fa-question-circle me-2" style={{ color: 'var(--fresh-green)' }}></i>What's your return policy?</h5>
                <p className="text-muted mb-0">If you're not satisfied with any product, contact us within 24 hours and we'll provide a replacement or refund.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      {/* <section id="footer">
        <hr className="text-black" />
        <div className="container-fluid padding-side padding-small" data-aos="fade-up">
          <footer className="row">
            <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
              <h4 className="display-6 fw-normal">Quick links</h4>
              <ul className="nav flex-column">
                <li className="nav-item mb-2"><Link to="/agroindex" className="p-0 text-dark">Home</Link></li>
                <li className="nav-item mb-2"><Link to="/about" className="p-0 text-dark">About Us</Link></li>
                <li className="nav-item mb-2"><Link to="/vegetables" className="p-0 text-dark">Vegetables</Link></li>
                <li className="nav-item mb-2"><Link to="/spices" className="p-0 text-dark">Spices</Link></li>
                <li className="nav-item mb-2"><Link to="/acontact" className="p-0 text-dark">Contact Us</Link></li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-3 offset-lg-1 mb-4 mb-lg-0"></div>
            <div className="col-md-6 col-lg-3 offset-lg-1 mb-4 mb-lg-0">
              <p className="m-0">© Copyright 2024 FreshHarvest.</p>
              <p>Farm Fresh Organic Vegetables & Fruits<br /> Delivered with love from our family to yours</p>
            </div>
          </footer>
        </div>
      </section> */}
    </div>
  );
};

export default Acontact;